import { NgModule } from '@angular/core';
import { AppTranslationLoaderModule } from '@kimaya/ngx-base-common-hive';
import { DecodeHtmlPipe } from './decode-html.pipe';
import { FilterPipe } from './filter.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { NFormatterPipe } from './n-formatter.pipe';

const COMPONENTS_EXPORT = [DecodeHtmlPipe, FilterPipe, SafeHtmlPipe, NFormatterPipe];
const COMPONENTS_ENTRY = [];
const COMPONENTS = [...COMPONENTS_EXPORT, ...COMPONENTS_ENTRY];

const MODULES_EXPORT = [AppTranslationLoaderModule];
const MODULES = [...MODULES_EXPORT];

@NgModule({
  declarations: [...COMPONENTS],
  entryComponents: [...COMPONENTS_ENTRY],
  imports: [...MODULES],
  exports: [...MODULES_EXPORT, ...COMPONENTS_EXPORT],
})
export class PipesModule {
}
